// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_22-1";
export var rateTableServiceLevelDropdown = "_22-3";
export var rateTableTypeDropdown = "_22-0";
export var rateTableValueModeDropdown = "_22-2";